import { useCallback } from 'react'
import type { FormikErrors } from 'formik'
import {
  LeadAssignmentRuleFormModel,
  LeadAssignmentRuleFormProps,
} from '../typings'

import { useOnSubmit } from './useOnSubmit'

export function useActions(props: LeadAssignmentRuleFormProps) {
  const { onSubmit, coverageBlockLabels, closeCoverageBlock } =
    useOnSubmit(props)

  const onValidate = useCallback((model: LeadAssignmentRuleFormModel) => {
    const { name, description, assignmentRuleConditions, salesTeamIds } = model
    const errors: FormikErrors<LeadAssignmentRuleFormModel> = {}

    if (!name) errors.name = 'Required'
    else {
      if (name.length > 50) errors.name = 'Max length 50 characters'
      if (name.trim().length < 5) errors.name = 'Min length 5 characters'
    }

    if (description && description.length && description.trim().length > 0) {
      if (description.length > 150)
        errors.description = 'Max length 150 characters'
      if (description.trim().length < 5)
        errors.description = 'Min length 5 characters'
    }

    if (assignmentRuleConditions.length == 0) {
      errors.assignmentRuleConditions = 'Required'
    }

    if (salesTeamIds.length === 0) errors.salesTeamIds = 'Required'
    return errors
  }, [])

  return {
    onSubmit,
    onValidate,
    coverageBlockLabels,
    closeCoverageBlock,
  }
}
